import {DataTransferObject} from './DataTransferObject';
import {Model} from '../Models';

export class VisitorSurveyResultDTO extends DataTransferObject {
  eventId: string | number = 0;
  orderId: string | number = 0;
  customerEmail: string = '';
  results: any = {};

  fromData(existingResult: VisitorSurveyResultDTO): VisitorSurveyResultDTO {
    const dto = new VisitorSurveyResultDTO();
    dto.eventId = existingResult.eventId;
    dto.orderId = existingResult.orderId;
    dto.customerEmail = existingResult.customerEmail;
    dto.results = existingResult.results;
    return dto;
  }

  fromModel(model: Model): VisitorSurveyResultDTO {
    return new VisitorSurveyResultDTO();
  }
}
